<template>
  <v-select
    v-model="item"
    dir="rtl"
    :clearable="clearable"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :loading="loading"
    @open="onOpen"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

export default {
  name: 'ZUser',
  props: {
    value: {
      type: Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      val: this.value,
      loading: false,
    }
  },
  computed: {
    item: {
      get() {
        if (this.value) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  methods: {
    get() {
      if (this.items.length === 0) {
        this.loading = true
        this.$http.post(
          this.$api.user.getall, {},
        )
          .then(res => {
            this.items = res.data.map(x => ({ Id: x.Id, Title: `${x.Name} ${x.Family}` }))
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
